import { Button, Flex, Popconfirm, Tag, Tooltip, Typography } from "antd";
import { TagActiveStatus } from "../../../badge-and-tag/ERP";
import dayjs from 'dayjs';
import { DeleteOutlined, EditOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { capitalized } from "../../../../utils/util";
/** get items column */
export const columnsPkType = ({handleChoose, handleEdit, handleDeleted})=>{
    const Link = Typography.Link;
    const LChoose = ({children, record}) => (
      <Link 
      className="text-select" 
      onClick={()=>handleChoose(record)} 
      disabled={record?.active_status === 'ปิดการใช้งาน'} >{children}</Link>
    );
    return [
      {
        title: "Packaging Code",
        key: "pk_code",
        dataIndex: "pk_code", 
        render: (v, record) => <LChoose record={record}>{v}</LChoose>
      },
      {
        title: "Packaging Type",
        key: "pk_name",
        dataIndex: "pk_name", 
        render: (v, record) => <LChoose record={record}>{v}</LChoose>
      },
       {
        title: "Packing Type",
        dataIndex: "pktype_name",
        key: "pktype_name",
        render: (h, record)=>!!h && (
          <LChoose record={record}>
            <Tag color="#3b5999" >{capitalized(h || "")}</Tag>
          </LChoose>
        ),
      },
    ]
};

export const columnPackagingSingle = ({handleChoose})=>{
  const Link = Typography.Link;
  const LChoose = ({children, record}) => (
    <Link 
    className="text-select" 
    onClick={()=>handleChoose(record)} 
    disabled={record?.active_status === 'ปิดการใช้งาน'} >{children}</Link>
  );
  return [
    {
      title: "Package Name",
      key: "pkname",
      dataIndex: "pkname",
      width:200,
      ...ellipsis(),
      render: (v, record) => <LChoose record={record}>{v}</LChoose>
    },
    {
      title: "Package Name(TH)",
      key: "pknameTH",
      dataIndex: "pknameTH",
      width:180,
      ...ellipsis(),
      render: (v, record) => <LChoose record={record}>{v}</LChoose>
    },
    {
      title: "Express Code",
      dataIndex: "expscode",
      key: "expscode", 
      render: (v, record) => <LChoose record={record}>{v}</LChoose>
    },
    {
      title: "Package Type",
      dataIndex: "pktype",
      key: "pktype",
      render: (h, record)=>!!h && (
        <LChoose record={record}>
          <Tag color="#3b5999" >{capitalized(h || "")}</Tag>
        </LChoose>
      ),
    },
  ]
};

const ellipsis = () => {
  return {  
    ellipsis: {
      showTitle: false,
    },
    render: (v) => (
      <Tooltip placement="topLeft" title={v}>
        {v}
      </Tooltip>
    ),  
  }
}

export const columns = ()=>{
  return [
    {
      title: "Package Name",
      key: "pkname",
      dataIndex: "pkname",
      width:200,
      ...ellipsis()
    },
    // {
    //   title: "Package Name(TH)",
    //   key: "pknameTH",
    //   dataIndex: "pknameTH",
    //   width:180,
    //   ...ellipsis()
    // },
    // {
    //   title: "Express Code",
    //   dataIndex: "expscode",
    //   key: "expscode", 
    // },
    {
      title: "Express Name",
      dataIndex: "expsname",
      key: "expsname", 
      ...ellipsis()
    },
    {
      title: "Supplier",
      dataIndex: "supname",
      key: "supname",
      render: (_, v)=>!!v.supcode && <Typography.Text>{v.supcode}/{v.supname}</Typography.Text>,
      ...ellipsis()
    },
    {
      title: "Package Type",
      dataIndex: "pktype",
      key: "pktype",
      render: (h)=>!!h && <Tag color="#3b5999" >{capitalized(h || "")}</Tag>,
    },
  ]
};